import { T as d } from "../../chunks/Textarea.BsmL3mV8.js";
import { j as r } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import { useFormContext as f } from "react-hook-form";
import { d as F, e as j, f as p, b as u, g as w } from "../../chunks/Form.LdCd9gH2.js";
import { c as T } from "../../chunks/index.CxSWpsOB.js";
const g = ({
  label: e,
  subcopy: a,
  note: i,
  name: x,
  fullWidth: o = !1,
  disabled: s,
  readOnly: m,
  placeholder: n,
  ...t
}) => {
  const {
    control: c
  } = f();
  return /* @__PURE__ */ r.jsx(F, { control: c, name: x, render: ({
    field: l
  }) => /* @__PURE__ */ r.jsxs(j, { disabled: s, readOnly: m, className: T({
    "tw-w-full tw-flex-1": o
  }), children: [
    !!e && /* @__PURE__ */ r.jsx(p, { subcopy: a, required: t.required, children: e }),
    /* @__PURE__ */ r.jsx(u, { forwardErrorMsg: !0, children: /* @__PURE__ */ r.jsx(d, { fullWidth: o, disabled: s, readOnly: m, placeholder: n, ...t, ...l }) }),
    /* @__PURE__ */ r.jsx(w, { children: i })
  ] }) });
};
g.displayName = "TextareaField";
export {
  d as Textarea,
  g as TextareaField
};
//# sourceMappingURL=index.js.map
